import React from 'react';
import { } from '@mui/material';
import InsightsHerosection from '../components/INSIGHTSRM/InsightsHerosection';
import IntrinsicInsights from '../components/INSIGHTSRM/IntrinsicInsights';

const ProductInsightRm = () => {
  

  return (
    <>
      <InsightsHerosection/>
      <IntrinsicInsights/>

      
    </>
  );
};

export default ProductInsightRm;